module.exports = __webpack_public_path__ + "media/search/special_purpose_grayscale-be350031.png";